import { render } from "./CreateReleaseForm.vue?vue&type=template&id=324072bc"
import script from "./CreateReleaseForm.vue?vue&type=script&lang=js"
export * from "./CreateReleaseForm.vue?vue&type=script&lang=js"

import "./CreateReleaseForm.vue?vue&type=style&index=0&id=324072bc&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__